import { Link2, ShieldCheck, FileText } from 'lucide-react'
import { Link } from 'react-router-dom'

const CAMPO_LABEL_SUBMISSAO = {
  nome: 'Nome completo',
  cpf_cnpj: 'CPF/CNPJ',
  telefone: 'WhatsApp/Telefone',
  email: 'E-mail',
  endereco: 'Endereço',
  numero: 'Número',
  complemento: 'Complemento',
  bairro: 'Bairro',
  cidade: 'Cidade',
  estado: 'Estado',
  cep: 'CEP',
  inscricao_estadual: 'Inscrição Estadual',
  observacoes: 'Observações',
}

/**
 * Card de um envio do link de cadastro público.
 * Props:
 * - submissao: dado retornado pelo backend (cadastro_publico/utils.py resolver_submissao)
 * - mostrarCliente: se true, exibe o nome do cliente (link pro detalhe) no header — usado na
 *   listagem geral (todos os clientes); omitido na aba "Cadastro Público" dentro do próprio cliente.
 */
export default function SubmissaoCadastroPublicoCard({ submissao, mostrarCliente = false }) {
  const dataHora = submissao.created_at
    ? new Date(submissao.created_at).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
    : '—'

  const camposPreenchidos = Object.keys(CAMPO_LABEL_SUBMISSAO)
    .filter(campo => (submissao[campo] || '').toString().trim())
    .map(campo => ({ label: CAMPO_LABEL_SUBMISSAO[campo], valor: submissao[campo] }))

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4 pb-4 border-b border-gray-100">
        <div className="flex items-center gap-2 text-sm text-gray-700">
          <Link2 className="w-4 h-4 text-blue-500" />
          {mostrarCliente && submissao.cliente_id ? (
            <Link to={`/clientes/${submissao.cliente_id}`} className="font-medium text-blue-700 hover:text-blue-900">
              {submissao.cliente_nome || submissao.nome || `Cliente #${submissao.cliente_id}`}
            </Link>
          ) : (
            <span className="font-medium">Envio</span>
          )}
          <span className="text-xs text-gray-400">em {dataHora}</span>
          {submissao.ip_address && <span className="text-xs text-gray-400">· IP {submissao.ip_address}</span>}
        </div>
        {submissao.aceite_lgpd ? (
          <span className="flex items-center gap-1 text-xs font-medium text-green-700 bg-green-50 px-2 py-0.5 rounded-full">
            <ShieldCheck className="w-3 h-3" /> Aceitou os termos
          </span>
        ) : (
          <span className="text-xs font-medium text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full">Sem aceite registrado</span>
        )}
      </div>

      {camposPreenchidos.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
          {camposPreenchidos.map((c, i) => (
            <div key={i}>
              <p className="text-xs text-gray-500">{c.label}</p>
              <p className="text-sm text-gray-800">{c.valor}</p>
            </div>
          ))}
        </div>
      )}

      {submissao.respostas?.length > 0 && (
        <div className="pt-3 border-t border-gray-100 space-y-3">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Perguntas personalizadas</p>
          {submissao.respostas.map((r) => (
            <div key={r.pergunta_id}>
              <p className="text-xs text-gray-500">{r.label}</p>
              {r.tipo === 'upload' ? (
                r.arquivo_url ? (
                  <a href={r.arquivo_url} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 mt-0.5">
                    <FileText className="w-4 h-4" /> Ver arquivo enviado
                  </a>
                ) : (
                  <p className="text-sm text-gray-400">Nenhum arquivo</p>
                )
              ) : (
                <p className="text-sm text-gray-800">{r.valor}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
